<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Licencas</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo"/>												
					</template>
				</Toolbar>

				<DataTable :value="licencas" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>				
					<Column field="descricao" header="Descrição" sortable></Column>
					<Column field="dataRegistro" header="Data Ativação" sortable>
						<template #body="slotProps">
							<label>{{ formatarData(slotProps.data.dataRegistro, true) }}</label>
						</template>
					</Column>
					<Column field="dataAtualizacao" header="Data Atualização" sortable>
						<template #body="slotProps">
							<label>{{ formatarData(slotProps.data.dataAtualizacao, true) }}</label>
						</template>
					</Column>
					<Column field="dataValidade" header="Data Validade" sortable>
						<template #body="slotProps">
							<label>{{ formatarData(slotProps.data.dataValidade, false) }}</label>
						</template>
					</Column>
					<Column field="quantidadeEquipamentos" header="Qtd. Equipamentos" sortable></Column>	
					<Column field="ativada" header="Status" sortable>
						<template #body="slotProps">
							<label v-if="slotProps.data.ativada">Ativada</label>
                            <label v-else>Aguardando Ativação</label>
						</template>
					</Column>			
					<Column>						
						<template #body="slotProps">
							<SplitButton label="Ações" class="p-button-secondary" :model="acoes(slotProps.data)" appendTo="body" ></SplitButton>						
						</template>						
					</Column>
				</DataTable>						

			</div>
		</div>

		<Dialog :visible.sync="exibirDialogNovo" header="Nova Licença" :modal="true">
			<div class="p-fluid p-formgrid p-grid">                        
				<div class="p-field p-col-12">
					<label>Pacote de Permissões</label>                           
					<Dropdown v-model="licenca.descricao" :options="pacotes" optionLabel="nome" optionValue="valor"/>
					<small class="p-invalid" v-if="enviandoForm && !licenca.descricao">Selecione o pacote de permissões</small>
				</div>
			</div>
			<div class="p-fluid p-formgrid p-grid">                        
				<div class="p-field p-col-12">
					<label>Quantidade de Equipamentos</label>                           
					<InputNumber v-model.trim="licenca.quantidadeEquipamentos" :useGrouping="false" />
					<small class="p-invalid" v-if="enviandoForm && !licenca.quantidadeEquipamentos">Informe a quantidade de equipamentos</small>
				</div>
			</div>
			<div class="p-fluid p-formgrid p-grid">                        
				<div class="p-field p-col-12">
					<label>Validade (em meses)</label>                           
					<InputNumber v-model.trim="licenca.quantidadeMeses" :useGrouping="false" />
					<small class="p-invalid" v-if="enviandoForm && !licenca.quantidadeMeses">Informe a quantidade de meses</small>
				</div>
			</div>
			<Message severity="warn">Após salvar, um e-mail será enviado para o cliente com informações para a ativação.</Message>
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogNovo=false"/>
				<Button label="Salvar" icon="pi pi-check" @click="salvar"/>
			</template>
		</Dialog>

		<Dialog :visible.sync="exibirDialogAtualiza" header="Editar Licença" :modal="true">
			<div class="p-fluid p-formgrid p-grid">                        
				<div class="p-field p-col-12">
					<label>Pacote de Permissões</label>                           
					<Dropdown v-model="licencaEditar.descricao" :options="pacotes" optionLabel="nome" optionValue="valor" :disabled="!licencaEditar.atualizarPacote"/>
					<small class="p-invalid" v-if="enviandoForm && !licencaEditar.descricao">Selecione o pacote de permissões</small>
				</div>
			</div>
			<div class="p-fluid p-formgrid p-grid"> 
				<div class="p-field-checkbox p-col-12">                        
					<Checkbox v-model="licencaEditar.atualizarPacote" :binary="true"/>     
					<label>Atualizar Pacote de Permissões</label>                   
				</div>
			</div>
			<div class="p-fluid p-formgrid p-grid">                        
				<div class="p-field p-col-12">
					<label>Quantidade de Equipamentos</label>                           
					<InputNumber v-model.trim="licencaEditar.quantidadeEquipamentos" :useGrouping="false"/>
					<small class="p-invalid" v-if="enviandoForm && !licencaEditar.quantidadeEquipamentos">Informe a quantidade de equipamentos</small>
				</div>
			</div>			
			<div class="p-fluid p-formgrid p-grid">                        
				<div class="p-field p-col-12">
					<label>Validade (em meses)</label>                           
					<InputNumber v-model.trim="licencaEditar.quantidadeMeses" :useGrouping="false" :disabled="!licencaEditar.estenderValidade"/>
					<small class="p-invalid" v-if="enviandoForm && !licencaEditar.quantidadeMeses && licencaEditar.estenderValidade">Informe a quantidade de meses</small>
				</div>
			</div>
			<div class="p-fluid p-formgrid p-grid"> 
				<div class="p-field-checkbox p-col-12">                        
					<Checkbox v-model="licencaEditar.estenderValidade" :binary="true"/>     
					<label>Estender Validade</label>                   
				</div>
			</div>
			<Message severity="warn">Após salvar, um e-mail será enviado para o cliente com informações para a atualização.</Message>
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogAtualiza=false"/>
				<Button label="Salvar" icon="pi pi-check" @click="alterar"/>
			</template>
		</Dialog>

		<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
			<div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
				<span>Excluir Licença?</span><br><br>
				<label><b>Descrição</b>: {{ licencaEditar.descricao }}</label><br>
				<label><b>Validade</b>: {{ formatarData(licencaEditar.dataValidade) }}</label><br>
				<label><b>Status</b>: {{ licencaEditar.ativo ? 'Ativada' : 'Aguardadndo Ativação' }}</label><br>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarExcluir=false"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
			</template>
		</Dialog>

		<Dialog :visible.sync="exibirDialogConfirmarReenviar" header="Confirmar" :modal="true" :style="{width: '450px'}">
			<div class="confirmation-content">
				<span>Reenviar E-mail?</span><br><br>
				<label><b>Descrição</b>: {{ licencaEditar.descricao }}</label><br>
				<label><b>Validade</b>: {{ formatarData(licencaEditar.dataValidade) }}</label><br>
				<label><b>Status</b>: {{ licencaEditar.ativo ? 'Ativada' : 'Aguardadndo Ativação' }}</label><br>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarReenviar=false"/>
				<Button label="Sim" icon="pi pi-check" @click="reenviar" />
			</template>
		</Dialog>

	</div>
</template>

<script>

import ClienteIKAcessoService from '@/service/ClienteIKAcessoService.js';
import Licenca from '@/model/LicencaIKAcesso.js';
import { exibirMensagemSis } from '@/global';

export default {
	clienteService: null,
	props: ['idCliente'],
	data() {
		return {		
			exibirDialogConfirmarReenviar: false,
			exibirDialogConfirmarExcluir: false,
			exibirDialogAtualiza: false,
			exibirDialogNovo: false,
			enviandoForm: false,
            licencas: [],
			pacotes: [],
			cliente: null,
			licenca: new Licenca(),
			licencaEditar: new Licenca(),
			filtro: {}
		}
	},
	methods: {	
		novo() {
			this.licenca = new Licenca();
			this.licenca.descricao = 'Acesso';
			this.enviandoForm = false;
			this.exibirDialogNovo = true;			
		},				
		salvar() {
			this.enviandoForm = true;
			if(!this.licenca.descricao || !this.licenca.quantidadeEquipamentos || !this.licenca.quantidadeMeses) {
				return;
			}
			this.licenca.sistemaAcesso = false;
            this.licenca.sistemaEscola = false;
            this.licenca.sistemaRefeicao = false;
            this.pacotes.forEach(pacote => {
                if(this.licenca.descricao == pacote.nome) {
                    this.licenca.sistemaAcesso = pacote.permissao.sistemaAcesso;
                    this.licenca.sistemaEscola = pacote.permissao.sistemaEscola;
                    this.licenca.sistemaRefeicao = pacote.permissao.sistemaRefeicao;
                }
            });
			let requisicao = {
				cliente: this.cliente,
				licenca: this.licenca
			}
			this.clienteService.salvarLicenca(requisicao)
			.then(resp => {		
				if(resp.data.status == 200) {
                    exibirMensagemSis(this, resp.data.entity.mensagem, false);
					this.exibirDialogNovo = false;
					this.listar();
                } else {
                    exibirMensagemSis(this, resp.data.entity.mensagem, true);
                }
			}).catch(erro => {              
				if(erro.response && erro.response.data.status == 401) {
					exibirMensagemSis(this, erro.response.data.message, true);					
				} else {
					exibirMensagemSis(this, 'Erro interno do servidor', true);
					console.log(erro.request)
				} 
			});
		},
		alterar() {
			this.enviandoForm = true;
			if(!this.licencaEditar.descricao || !this.licencaEditar.quantidadeEquipamentos || !this.licencaEditar.quantidadeMeses) {
				return;
			}
			this.licencaEditar.sistemaAcesso = false;
            this.licencaEditar.sistemaEscola = false;
            this.licencaEditar.sistemaRefeicao = false;
            this.pacotes.forEach(pacote => {
                if(this.licencaEditar.descricao == pacote.nome) {
                    this.licencaEditar.sistemaAcesso = pacote.permissao.sistemaAcesso;
                    this.licencaEditar.sistemaEscola = pacote.permissao.sistemaEscola;
                    this.licencaEditar.sistemaRefeicao = pacote.permissao.sistemaRefeicao;
                }
            });
			let requisicao = {
				cliente: this.cliente,
				licenca: this.licencaEditar
			}
			this.clienteService.alterarLicenca(requisicao)
			.then(resp => {		
				if(resp.data.status == 200) {
                    exibirMensagemSis(this, resp.data.entity.mensagem, false);
					this.exibirDialogAtualiza = false;
					this.listar();
                } else {
                    exibirMensagemSis(this, resp.data.entity.mensagem, true);
                }
			}).catch(erro => {              
				if(erro.response && erro.response.data.status == 401) {
					exibirMensagemSis(this, erro.response.data.message, true);					
				} else {
					exibirMensagemSis(this, 'Erro interno do servidor', true);
					console.log(erro.request)
				} 
			});
		},
		excluir() {			
			this.clienteService.excluirLicenca(this.licencaEditar)
			.then(resp => {		
				if(resp.data.status == 200) {
                    exibirMensagemSis(this, resp.data.entity.mensagem, false);
					this.exibirDialogConfirmarExcluir = false;
					this.listar();
                } else {
                    exibirMensagemSis(this, resp.data.entity.mensagem, true);
                }
			}).catch(erro => {              
				if(erro.response && erro.response.data.status == 401) {
					exibirMensagemSis(this, erro.response.data.message, true);					
				} else {
					exibirMensagemSis(this, 'Erro interno do servidor', true);
					console.log(erro.request)
				} 
			});
		},
		reenviar() {
			let requisicao = {
				cliente: this.cliente,
				licenca: this.licencaEditar
			}	
			this.clienteService.reenviarEmailLicenca(requisicao)
			.then(resp => {		
				if(resp.data.status == 200) {
                    exibirMensagemSis(this, resp.data.entity.mensagem, false);
					this.exibirDialogConfirmarReenviar = false;					
                } else {
                    exibirMensagemSis(this, resp.data.entity.mensagem, true);
                }
			}).catch(erro => {              
				if(erro.response && erro.response.data.status == 401) {
					exibirMensagemSis(this, erro.response.data.message, true);					
				} else {
					exibirMensagemSis(this, 'Erro interno do servidor', true);
					console.log(erro.request)
				}
			});
		},
		listar() {
			if(this.idCliente) {
				this.clienteService.listarLicencas(this.idCliente)
				.then(resp => {		
					this.licencas = resp.data.entity;
					console.log(this.licencas)
					let objCliente = JSON.parse(sessionStorage.getItem('CLIENTE_LICENCAS'));					
					sessionStorage.removeItem('CLIENTE_LICENCAS');
					if(objCliente) {
						this.cliente = objCliente;
					}					
				}).catch(erro => {              
					if(erro.response && erro.response.data.status == 401) {
						exibirMensagemSis(this, erro.response.data.message, true);					
					} else {
						exibirMensagemSis(this, 'Erro interno do servidor', true);
						console.log(erro.request)
					} 
				});
			}			 
		},	
		acoes(licenca) {
			let acoes =[
				{label: 'Editar', icon: 'pi pi-pencil', idLicenca:licenca.id, command: (event) => {
						this.licencas.forEach(licenca => {
							if(licenca.id == event.item.idLicenca) {
								this.licencaEditar = {...licenca};
							}
						});
						this.enviandoForm = false;
						this.exibirDialogAtualiza = true;
					}
				},				
				{label: 'Reenviar E-mail', icon: 'pi pi-id-card', idLicenca:licenca.id, command: (event) => {
						this.licencas.forEach(licenca => {
							if(licenca.id == event.item.idLicenca) {
								this.licencaEditar = {...licenca};
							}
						});
						this.exibirDialogConfirmarReenviar = true;						
					}
				},
				{label: 'Excluir', icon: 'pi pi-trash', idLicenca:licenca.id, command: (event) => {
						this.licencas.forEach(licenca => {
							if(licenca.id == event.item.idLicenca) {
								this.licencaEditar = {...licenca};
							}
						});
						this.exibirDialogConfirmarExcluir = true;						
					}
				},
			];
			return acoes;
		},
		formatarData(strDate, comHora) {
            let data = '';
			if(!strDate) {
				return '';
			}
            if(!comHora) {
                let partes = strDate.split('-');
                data = partes[2]+'/'+partes[1]+'/'+partes[0];
            } else {
				let arrData = strDate.split(' ');
				let partes = arrData[0].split('-');
                data = partes[2]+'/'+partes[1]+'/'+partes[0]+' '+arrData[1];
            }
            return data;
        },
		carregarPacotesPermissoes() {
            this.pacotes.push({ nome: 'Acesso', valor: 'Acesso', permissao: { sistemaAcesso: true, sistemaEscola: false, sistemaRefeicao: false } });
            this.pacotes.push({ nome: 'Acesso + Escola', valor: 'Acesso + Escola', permissao: { sistemaAcesso: true, sistemaEscola: true, sistemaRefeicao: false }  });
            this.pacotes.push({ nome: 'Acesso + Refeição', valor: 'Acesso + Refeição', permissao: { sistemaAcesso: true, sistemaEscola: false, sistemaRefeicao: true }  });            
            this.pacotes.push({ nome: 'Acesso + Escola + Refeição', valor: 'Acesso + Escola + Refeição', permissao: { sistemaAcesso: true, sistemaEscola: true, sistemaRefeicao: true }  });             
        }	
	},	
	created() {
		this.clienteService = new ClienteIKAcessoService();
		this.carregarPacotesPermissoes();
		this.listar();
	},	
}
</script>

<style scoped>
</style>